// Text-driving beats of the 12s loop, in ms. The rest of the choreography is
// declared as keyframe percentages in ./heroScene.scss — these values are
// duplicated there, so retiming means editing both.
export const HERO_LOOP_MS = 12000

export const TYPE_START_MS = 6850
export const TYPE_STEP_MS = 105
export const TYPE_CARET_HOLD_MS = 200
export const FIELD_CLEAR_MS = 8460
export const TOTAL_START_MS = 8520
export const TOTAL_DURATION_MS = 900

export const HERO_ITEMS = [
  { key: 'bowl', price: 14.5 },
  { key: 'salad', price: 13.5 },
] as const

export const HERO_DISCOUNT = 10

export const HERO_ITEM_TOTAL = HERO_ITEMS.reduce(
  (sum, item) => sum + item.price,
  0
)

export const formatUsd = (value: number) => `$${value.toFixed(2)}`

export type HeroTextState = {
  typedCount: number
  total: number
  isTyping: boolean
}

const clamp01 = (value: number) => Math.min(1, Math.max(0, value))

const easeOutCubic = (progress: number) => 1 - Math.pow(1 - progress, 3)

const roundToCents = (value: number) => Math.round(value * 100) / 100

export const heroTextStateAt = (
  loopMs: number,
  codeLength: number
): HeroTextState => {
  const typingEndMs = TYPE_START_MS + codeLength * TYPE_STEP_MS
  const isBeforeTyping = loopMs < TYPE_START_MS
  const isFieldCleared = loopMs >= FIELD_CLEAR_MS

  const typedCount =
    isBeforeTyping || isFieldCleared
      ? 0
      : Math.min(
          codeLength,
          Math.floor((loopMs - TYPE_START_MS) / TYPE_STEP_MS)
        )

  const countUpProgress = clamp01((loopMs - TOTAL_START_MS) / TOTAL_DURATION_MS)

  return {
    typedCount,
    isTyping: !isBeforeTyping && loopMs < typingEndMs + TYPE_CARET_HOLD_MS,
    total: roundToCents(
      HERO_ITEM_TOTAL - HERO_DISCOUNT * easeOutCubic(countUpProgress)
    ),
  }
}

export const HERO_END_STATE: HeroTextState = {
  typedCount: 0,
  isTyping: false,
  total: HERO_ITEM_TOTAL - HERO_DISCOUNT,
}
